import { Injectable } from '@angular/core';
import {
  TComponentNames,
  TTvDashboardWebsocketComponentSubscribeMessage,
  TTvDashboardWebsocketConfig,
  TWebSocketConnectReason,
} from '@monorepo/types';
import { select, Store } from '@ngrx/store';
import { TTvDashboardState } from './tv-dashboard.model';
import * as TvDashboardActions from './tv-dashboard.actions';
import { getWebsocketConnectionStatus, getComponentDataByChannelId } from './tv-dashboard.selectors';
@Injectable({
  providedIn: 'root',
})
export class TvDashboardFacade {
  constructor(private store: Store<TTvDashboardState>) {}

  connectWebsocket(config: TTvDashboardWebsocketConfig, reason: TWebSocketConnectReason) {
    this.store.dispatch(new TvDashboardActions.ConnectWebSocket(config, reason));
  }

  getWebsocketConnectionStatus() {
    return this.store.pipe(select(getWebsocketConnectionStatus));
  }

  sendDataToWebsocket(data: TTvDashboardWebsocketComponentSubscribeMessage) {
    this.store.dispatch(new TvDashboardActions.SendDataToWebsocket(data));
  }

  mapChannelToComponent(channelId: string, componentName: TComponentNames) {
    this.store.dispatch(new TvDashboardActions.MapChannelToComponent(channelId, componentName));
  }

  getComponentDataByChannelId<T extends TComponentNames>(componentName: T, channelId: string) {
    return this.store.pipe(select(getComponentDataByChannelId(componentName, channelId)));
  }
}
